import {FC, useState, useEffect, Fragment} from 'react'

import './style.css'

import {PageTitle} from '_metronic/layout/core'
import Proposal from './Proposal'
import Document from './Document'
import TeamList from '../Register/TeamList'
import HTMLRenderer from 'react-html-renderer'
import AnnouncementInterview from './AnnouncementInterview'

import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import NotPassed from './NotPassed'
import Passed from './Passed'

const api = new Api()

type PropsBorderTab = {
  color: string
  width: string
}

const BorderTab: FC<PropsBorderTab> = ({color, width}) => {
  return (
    <p
      style={{
        border: `2px solid ${color}`,
        width: width,
        gap: '0px',
        borderRadius: '3px 3px 0px 0px',
        opacity: '0px',
      }}
    />
  )
}

type PropsRegisteredPage = {
  dataPana: any
  handleToPage: any
}

const RegisteredPageContent: FC<PropsRegisteredPage> = ({dataPana, handleToPage}) => {
  const [activeTab, setActiveTab] = useState<string>('propsal')
  const [loading, setLoading] = useState<boolean>(false)
  const [dataStatus, setDataStatus] = useState<any>({})
  const navigate = useNavigate()

  useEffect(() => {
    setActiveTab('proposal')
    getPublishTime()
  }, [])

  const handleClickTab = (type: string) => {
    setActiveTab(type)
  }

  const currentTab = (tab: string) => {
    switch (tab) {
      case 'document':
        return <Document dataPana={dataPana} />
      case 'teams':
        return <TeamList listOnly={true} lists={dataPana} refreshTeams={false} asTeam={false} />
      default:
        return <Proposal dataPana={dataPana} handleToPage={handleToPage} />
    }
  }

  const getPublishTime = () => {
    setLoading(true)
    api
      .getPublisTimeStatus()
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        setDataStatus(data)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const announcment = (dataPana: any) => {
    if (dataStatus?.kehadiran && dataStatus?.kehadiran?.is_hadir == 0) {
      return <NotPassed dataPana={dataPana} />
    } else if (dataPana?.is_lulus == 1 && dataPana?.is_lolos_verifikator == true) {
      return <Passed dataPana={dataPana} />
    } else if (dataPana?.is_lulus == 0) {
      return <NotPassed dataPana={dataPana} />
    } else if (
      dataPana?.is_lolos_verifikator == true &&
      (dataPana?.is_lulus == null || dataPana?.is_lulus == '')
    ) {
      return <AnnouncementInterview dataPana={dataPana} />
    } else {
      return <NotPassed dataPana={dataPana} />
    }
  }

  return (
    <div className='col-md-12'>
      {/* {(dataStatus?.kelulusan_publish == true || dataStatus?.wawancara_publish == true) && (
        <>
          <p className='h5'>Pengumuman</p>
          <div className='mt-5 mb-10'>{announcment(dataPana)}</div>
        </>
      )} */}

      <p className='h5'>Status Pendaftaran</p>
      <div className='card mt-5 d-flex justify-content-center'>
        <div className='px-10 p-8 mt-3' style={{background: '#FFFFFF', borderRadius: '6.18px'}}>
          <div className='row border rounded p-5'>
            <div className='d-flex justify-content-start'>
              <img
                src={require('../../assets/img/avatar-pana.png')}
                alt='PANA'
                id='avatar-image'
                className='img-fluid'
              />

              <div className='p-5'>
                {dataPana?.pendaftaran_locus_temas?.map((item: any, key: any) => {
                  if (item?.prioritas == 1) {
                    return (
                      <div key={key}>
                        <span className='h6'>
                          <HTMLRenderer html={item?.locus?.tema?.tema ?? ''} />
                        </span>
                        {dataPana?.judul_proposal && (
                          <p className='mt-2 mb-0 text-muted' style={{fontSize: '0.95rem'}}>
                            <strong>Tema Essay:</strong> {dataPana.judul_proposal}
                          </p>
                        )}
                      </div>
                    )
                  }
                })}

                <p style={{textTransform: 'capitalize'}}>
                  {dataPana?.tipe} &#x2022; {dataPana?.nomor_pendaftaran ?? '-'} &#x2022; {'   '}
                  <span className='badge' style={{backgroundColor: '#64748B', color: '#fff'}}>Berhasil Pendaftaran</span>
                </p>
              </div>
            </div>

            <div className='d-flex h6 mt-5'>
              <div
                style={{marginRight: '15px', cursor: 'pointer'}}
                onClick={() => handleClickTab('proposal')}
              >
                <p className={activeTab == 'proposal' ? 'text-primary' : 'text-black'}>
                  Informasi Essay
                </p>

                {activeTab == 'proposal' ? <BorderTab color={'#F95E2F'} width='138' /> : null}
              </div>

              <div
                style={{marginRight: '15px', cursor: 'pointer'}}
                onClick={() => handleClickTab('document')}
              >
                <p className={activeTab == 'document' ? 'text-primary' : 'text-black'}>Dokumen</p>

                {activeTab == 'document' ? <BorderTab color={'#F95E2F'} width='65' /> : null}
              </div>

              {dataPana?.tipe == 'kelompok' ? (
                <div style={{cursor: 'pointer'}} onClick={() => handleClickTab('teams')}>
                  <p className={activeTab == 'teams' ? 'text-primary' : 'text-black'}>Anggota</p>

                  {activeTab == 'teams' ? <BorderTab color={'#F95E2F'} width='65' /> : null}
                </div>
              ) : null}
            </div>

            {currentTab(activeTab)}
          </div>
        </div>
      </div>
    </div>
  )
}

const RegisteredPage: FC<PropsRegisteredPage> = ({dataPana, handleToPage}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'PANA',
            path: '/pana-beranda',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        My Application PANA
      </PageTitle>
      <RegisteredPageContent dataPana={dataPana} handleToPage={handleToPage} />
    </>
  )
}

export default RegisteredPage
